import { render } from "./ZoneTable.vue?vue&type=template&id=08b55f5e"
import script from "./ZoneTable.vue?vue&type=script&lang=js"
export * from "./ZoneTable.vue?vue&type=script&lang=js"
script.render = render

export default script